import { useMutate } from 'restful-react'
import { GetLgpdRequestsBody, GetLgpdRequestsResponse } from './interfaces'

const useGetLgpdRequests = () => {
    return useMutate<GetLgpdRequestsResponse, any, any, GetLgpdRequestsBody>('POST', '/lgpd')
}

export default useGetLgpdRequests
